import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';

import { useFilter } from './useFilter';

export function useSpecialtyTypesIds(): Array<number> | undefined {
  const specialtyTypes = useFilter(EAdvancedFilterType.specialtyTypes);

  return specialtyTypes?.map(specialtyType => specialtyType.id);
}
